import { MobileMenuLabel } from '@framework/ui/components/menu/MobileMenuLabel.tsx';
import { type ItemType } from 'antd/es/menu/interface';
import { type RoutePath } from '../RoutePaths.ts';
import { type LeafMenuItemsProps } from './MainMenu.tsx';

export function createMobileSubMenuItems(
  subMenu: LeafMenuItemsProps[],
  onClick: (to: RoutePath) => void,
): ItemType[] {
  return subMenu.map(subItem => ({
    key: subItem.menuKey,
    label: <MobileMenuLabel>{subItem.children}</MobileMenuLabel>,
    title: subItem.title,
    onClick: () => {
      onClick(subItem.to);
    },
  }));
}
